import type { ApiFilestackImageData } from '#/api/types/ApiFilestackImageData';
import { FilestackImage } from '#/components/FilestackImage/FilestackImage';
import { useI18n } from '#/i18n/hooks/useI18n';

import { OrgLogoLink } from './ListingViewSidebarImage.styled';

type Props = {
  orgLogo: ApiFilestackImageData | null;
  orgName: string | null;
  orgURLForCurrentLocale: string | null;
};

export function ListingViewSidebarImage({
  orgLogo,
  orgName,
  orgURLForCurrentLocale,
}: Props) {
  const { i18n } = useI18n();

  const imageElement = (
    <FilestackImage
      qaId="org-logo"
      width={180}
      height={128}
      data={orgLogo}
      alt={i18n('Logo of %(orgName)s', { orgName: orgName ?? '' })}
      objectPosition="left"
      noCrop
    />
  );

  return (
    orgLogo && (
      // oxlint-disable-next-line react/jsx-no-useless-fragment
      <>
        {orgURLForCurrentLocale ? (
          <OrgLogoLink to={orgURLForCurrentLocale}>{imageElement}</OrgLogoLink>
        ) : (
          imageElement
        )}
      </>
    )
  );
}
